import { useEffect } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router';
import { useQueryClient } from '@tanstack/react-query';
import { onUnauthorized, setCsrfToken } from '@/lib/api';
import { InstitutionProvider } from '@/lib/institution-context';
import { Toaster } from '@/components/ui/sonner';
import { AppShell } from '@/components/layout/AppShell';
import { EmptyState } from '@/components/states';
import { Button } from '@/components/ui/button';
import { SESSION_KEY, SessionProvider } from '@/features/auth/session';

/** Em 401 (sessão expirada/revogada): limpa a sessão e volta ao login preservando o destino. */
function UnauthorizedBridge() {
  const navigate = useNavigate();
  const location = useLocation();
  const qc = useQueryClient();
  useEffect(() => {
    onUnauthorized(() => {
      setCsrfToken(null);
      qc.setQueryData(SESSION_KEY, null);
      if (!location.pathname.startsWith('/entrar')) {
        navigate(`/entrar?next=${encodeURIComponent(location.pathname + location.search)}`, { replace: true });
      }
    });
    return () => onUnauthorized(null);
  }, [navigate, location, qc]);
  return null;
}

export function RootLayout() {
  return (
    <SessionProvider>
      <UnauthorizedBridge />
      <Outlet />
      <Toaster position="top-right" />
    </SessionProvider>
  );
}

export function ProtectedShell() {
  return (
    <InstitutionProvider>
      <AppShell />
    </InstitutionProvider>
  );
}

export function NotFound() {
  return (
    <EmptyState
      title="Página não encontrada"
      description="O endereço não existe ou foi movido."
      action={
        <Button asChild variant="outline" size="sm">
          <Link to="/">Ir para o painel</Link>
        </Button>
      }
    />
  );
}

